module.exports = __webpack_public_path__ + "images/landing/light/banner-video-preview_x2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/banner-video-preview_x2.jpg
// module id = rJ0m
// module chunks = 154